export default "__VITE_ASSET__821114f8__"